(function() {
	'use strict';
	angular.module('app.setup')
		.service('strategicGoalsService', strategicGoalsService);
	
	strategicGoalsService.$inject = ['$http', 'URLS', 'leanFilterService'];
	function strategicGoalsService($http, URLS, leanFilterService) {
		return {
			getGoals: getGoals,
			getGoalProjects: getGoalProjects,
			addGoal: addGoal,
			updateGoal: updateGoal,
			deleteGoal: deleteGoal
		};
		
		function getGoals(showArchive) {
			var pageUrl = buildUrl(showArchive);
			return $http.get(URLS.host + pageUrl)
				.then(getDataComplete)
				.catch(getDataFailed);
			
			function getDataComplete(response) {
				return response.data;
			}
			
			function getDataFailed(error) {
				return [];
			}
		}
		
		function addGoal(goal, siteId) {
			var goalCrudUrl = URLS.host + String.format(URLS.goalsCrud, siteId || globalConfig.factory.id);
		
			return $http.post(goalCrudUrl, goal)
				.then(addGoalSuccess, handleError);

			function addGoalSuccess(response) {
				return 'Goal created successfully';
			}
		}
		
		function updateGoal(goal, lastModified, siteId) {			
			var goalCrudUrl = URLS.host + String.format(URLS.goalsCrud, siteId || globalConfig.factory.id);
			return $http.put(goalCrudUrl + '/' + goal.ndx, goal, {headers: {'If-Unmodified-Since': lastModified}})
				.then(updateGoalSuccess, handleError);

			function updateGoalSuccess(response) {
				return response;
			}
		}
		
		function deleteGoal(goalNdx, siteId) {
			var goalCrudUrl = URLS.host + String.format(URLS.goalsCrud, siteId || globalConfig.factory.id);
			return $http.delete(goalCrudUrl + '/' + goalNdx)
			.then(deleteGoalSuccess, handleError);

			function deleteGoalSuccess(response) {
				return 'Goal deleted successfully';
			}	
		}
		
		function getGoalProjects(goalNdx, siteId) {
			var pageUrl = String.format(URLS.factoryGoals, siteId || globalConfig.factory.id) + '/' + goalNdx + '/Projects';
			return $http.get(URLS.host + pageUrl)
				.then(getDataComplete)
				.catch(getDataFailed);
			
			function getDataComplete(response) {
				return response.data;
			}
			
			function getDataFailed(error) {
				return [];
			}
		}
		
		function buildUrl(showArchive) {
			var url = String.format(URLS.factoryGoals, globalConfig.factory.id);
			url = addFilterQueryParams(url, showArchive);
			return url;
		}
		
		function addFilterQueryParams(url, showArchive) {
			var filterQueryParam = leanFilterService.getQueryParam();
			var parts = url.split('?');
			var qParams = '';
			if (parts.length > 1) {
				qParams = '?' + parts[1];
			}
			for (var i = 0; i < filterQueryParam.length; i++) {
				qParams = appendQueryParam(qParams, filterQueryParam[i].key, filterQueryParam[i].value);
			}
			qParams = appendQueryParam(qParams, 'showArchive', showArchive);
			return parts[0] + qParams;
		}
		
		function handleError (error) {
			if (error.status === 403) {
				return '';
			} else if (error.status === 412) {
				return error.data.error;
			}
			return 'Unknown server error';
		}
	}
})();